module.exports = __webpack_public_path__ + "img/e2i_Logo2Black_updated.bd9de98c.png";